import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        languageData: '<',
        scale: '<'
    },
    template: `
        <div class="modal-header" id="modal-header">
            <div class="heading01 heading01b">
                <h2>{{ 'skill.Edit skill scale' | translate }}</h2>
                <ul class="actions01">
                    <li class="primary"><a class="btn main" ng-click="vm.save()">{{ "skill.Save" | translate }}</a></li>
                    <li><a class="btn bordered02" ng-click="vm.uibModalInstance.dismiss()">{{ "skill.Cancel" | translate }}</a></li>
                </ul>
            </div>
            <div class="alert alert-danger" ng-if="vm.error">{{vm.error}}</div>
        </div>

        <!-- render form only when languageData and the selected language bucket exist -->
        <div class="modal-body" ng-if="vm.languageData && vm.languageData[vm.selectedLang]">
            <language-selector
                languages="vm.languages"
                selected="vm.selectedLang"
                data="vm.languageData"
                on-change="vm.onLangChange(lang, data)">
            </language-selector>

            <div class="form">
                <div class="row row-wide mt2em">
                    <div class="items">
                        <input
                            type="text"
                            placeholder="{{ 'skill.Enter name for the scale' | translate}}"
                            class="form-control wide"
                            ng-model="vm.languageData[vm.selectedLang].name"
                        >
                    </div>
                </div>

                <ul dnd-list="vm.languageData[vm.selectedLang].values" class="items06" ng-class="{'is-dragging': vm.down===true}">
                    <li ng-repeat="item in vm.languageData[vm.selectedLang].values"
                        dnd-draggable="item"
                        dnd-type="item.value"
                        dnd-moved="vm.languageData[vm.selectedLang].values.splice($index, 1)"
                        dnd-effect-allowed="move"
                        dnd-dragend="vm.onDragEnd()"
                        dnd-dragstart="vm.down=true"
                    >
                        <dnd-nodrag>
                            <div dnd-handle class="handle" ng-if="!vm.isSkillAssociatedToScale"></div>
                            <p class="show-on-drag">{{item.value}}</p>
                            <div class="form hide-on-drag">
                                <div class="rowgroup inline">
                                    <div class="row row-wide">
                                        <label class="label w100p">{{ 'skill.points' | translate }}</label>
                                        <div class="items w100p">
                                            <input type="text" class="form-control small03" ng-model="item.points" disabled>
                                        </div>
                                    </div>
                                    <div class="row row-wide primary">
                                        <label class="label w100p">{{ 'skill.Values' | translate }}</label>
                                        <div class="items w100p">
                                            <input type="text" class="form-control" ng-model="item.value">
                                        </div>
                                    </div>
                                    <a class="btn delete"
                                        ng-class="{'disabled': vm.isSkillAssociatedToScale}"
                                        ng-click="!vm.isSkillAssociatedToScale && vm.removeLevel($index)">Remove</a>
                                </div>
                            </div>
                        </dnd-nodrag>
                    </li>
                </ul>
                <ul class="actions01 mt1em">
                    <li>
                        <a class="btn bordered02"
                            ng-class="{'disabled': vm.isSkillAssociatedToScale}"
                            ng-click="!vm.isSkillAssociatedToScale && vm.addMoreLevels()">{{ 'skill.Add level' | translate }}
                        </a>
                    </li>
                </ul>
                <div class="alert alert-info mt1em" ng-if="vm.isSkillAssociatedToScale">
                    <p style="margin: 0;">{{ vm.getAssociationWarning() }}</p>
                    <p ng-if="vm.hasSkillsAssociation" style="margin: 10px 0 0 0;">
                        <strong>{{ 'skill.Associated skills' | translate }}:</strong>
                        <span ng-repeat="skill in vm.scale.skills">
                            <a ui-sref="authorized.user.skill.edit.skill({ id: skill.id })" target="_blank">{{
                                skill.activeI18n.name || ('Skill #' + skill.id)
                            }}</a><span ng-if="!$last">, </span>
                        </span>
                    </p>
                    <p ng-if="vm.hasPlanningGroupsAssociation" style="margin: 10px 0 0 0;">
                        <strong>{{ 'skill.Associated planning groups' | translate }}:</strong>
                        <span ng-repeat="apg in vm.scale.planningGroups">
                            <a ui-sref="authorized.courses.courses.edit.occurrence.automated.edit.general({
                                id: apg.courseId, planningGroupId: apg.id
                            })" target="_blank">{{ apg.name }}</a><span ng-if="!$last">, </span>
                        </span>
                    </p>
                </div>
            </div>
        </div>
    `
})

export default class {
    constructor (lodash, DATATABLES, SkillScaleResource, TokenService, toastr, $translate, $scope, I18nService,
                 $state) {
        this.lodash = lodash;
        this.dt = DATATABLES;
        this.TokenService = TokenService;
        this.toastr = toastr;
        this.$translate = $translate;
        this.$scope = $scope;
        this.skillScaleResource = SkillScaleResource;
        this.I18nService = I18nService;
        this.$state = $state;
    }

    $onInit () {
        this.companySupportedLanguages = this.TokenService.getCompanySupportedLanguages();
        this.languages = this.getSortedLanguages();
        this.languageData = this.languageData || {};
        this.scale = this.scale || null;

        this.values = { list: [], selected: null };
        this.defaultLanguage = this.getDefaultLanguage();
        this.selectedLang = this.defaultLanguage;
        this.isLanguageEnabled = false;

        this.tableOptions = this.lodash.merge({}, this.dt, {
            info: false,
            ordering: false,
            paging: false
        });

        this.$scope.$evalAsync(() => this.initFromBindings());
        const hasSkills = this.scale.skills && this.scale.skills.length > 0;
        const hasPlanningGroups = this.scale.planningGroups && this.scale.planningGroups.length > 0;
        this.isSkillAssociatedToScale = hasSkills || hasPlanningGroups;
        this.hasSkillsAssociation = hasSkills;
        this.hasPlanningGroupsAssociation = hasPlanningGroups;
        this.isSkillAssociatedToScale = (this.scale && this.scale.skills && this.scale.skills.length > 0);
    }

    $onChanges (changes) {
        if (changes.languageData || changes.scale) {
            // we pick up the new values in the next cycle
            this.$scope.$evalAsync(() => this.initFromBindings());
        }
    }

    initFromBindings () {
        // ensure languageData is an object
        this.languageData = this.languageData || {};

        // If scale is provided, populate missing languageData buckets from scale.scaleI18ns
        if (this.scale && this.scale.scaleI18ns) {
            Object.keys(this.scale.scaleI18ns).forEach(k => {
                const langKey = k; // keep original case (API uses 'EN','ET' etc.)
                const i18n = this.scale.scaleI18ns[k] || {};

                if (!this.languageData[langKey]) {
                    this.languageData[langKey] = { name: '', enabled: true, values: [] };
                }

                // only set name if it's not already set by passed languageData
                if ((!this.languageData[langKey].name || this.languageData[langKey].name === '') && i18n.name) {
                    this.languageData[langKey].name = i18n.name;
                }
            });
        }

        this.languages = this.getSortedLanguages();
        this.languages.forEach(langObj => {
            const lbl = langObj.label;
            if (!this.languageData[lbl]) {
                this.languageData[lbl] = { name: '', enabled: !!langObj.enabled, values: [] };
            }
            // if enabled not set, set from language list
            if (typeof this.languageData[lbl].enabled === 'undefined') {
                this.languageData[lbl].enabled = !!langObj.enabled;
            }
            if (!Array.isArray(this.languageData[lbl].values)) {
                this.languageData[lbl].values = [];
            }
        });

        // Re-evaluate default language in case enabled status changed or list changed
        this.defaultLanguage = this.getDefaultLanguage();

        if (!this.selectedLang || !this.languageData[this.selectedLang]) {
            // prefer defaultLanguage, else first available key
            if (this.defaultLanguage && this.languageData[this.defaultLanguage]) {
                this.selectedLang = this.defaultLanguage;
            }
            else {
                const keys = Object.keys(this.languageData);
                this.selectedLang = keys.length ? keys[0] : this.defaultLanguage;
            }
        }

        // Populate values arrays for each language code based on scale translations (on modal load)
        this.populateLanguageValuesFromScale();

        // populate values list for the selected language to drive the UI list
        this.buildValuesList();
    }

    onLangChange (lang, data) {
        this.selectedLang = lang;
        // Do NOT replace the root languageData with selector payload; merge into the specific language bucket
        if (!this.languageData || typeof this.languageData !== 'object' || Array.isArray(this.languageData)) {
            this.languageData = {};
        }
        if (lang) {
            // ensure bucket exists
            const current = this.languageData[lang] || { name: '', enabled: false, values: [] };
            const patch = (data && typeof data === 'object') ? data : { enabled: !!data };
            this.languageData[lang] = Object.assign({}, current, patch);
        }
        // Also sync the enabled state back to the languages list for UI consistency
        if (Array.isArray(this.languages) && lang) {
            const entry = this.languages.find(l => l && l.label === lang);
            if (entry && this.languageData[lang] && typeof this.languageData[lang].enabled !== 'undefined') {
                entry.enabled = !!this.languageData[lang].enabled;
            }
        }
    }

    populateLanguageValuesFromScale () {
        const codes = Object.keys(this.languageData || {});
        if (!codes.length) return;

        if (!this.scale || !Array.isArray(this.scale.proficiencies)) {
            codes.forEach(code => {
                if (!this.languageData[code]) this.languageData[code] = { name: '', enabled: true, values: [] };
                if (!Array.isArray(this.languageData[code].values)) this.languageData[code].values = [];
            });
            return;
        }

        codes.forEach(code => {
            if (!this.languageData[code]) this.languageData[code] = { name: '', enabled: true, values: [] };
            const list = [];
            this.scale.proficiencies.forEach(p => {
                const translations = p && p.skillProficiencyI18n || {};
                const translated = (translations[code] && translations[code].value) || (p.activeI18n && p.activeI18n.value) || '';
                // Include all proficiencies even if translation empty, to match structure
                list.push({ proficiencyId: p.id, points: p.points, value: translated });
            });
            this.languageData[code].values = list;
        });

        // Ensure all languages have the same number of values
        const lengths = codes.map(code => (this.languageData[code].values || []).length);
        const maxLength = lengths.length ? Math.max.apply(null, lengths) : 0;

        codes.forEach(code => {
            const list = this.languageData[code].values;
            while (list.length < maxLength) {
                list.push({ proficiencyId: null, points: list.length + 1, value: '' });
            }
        });

        this.reindexPoints();
    }

    buildValuesList () {
        const lang = this.selectedLang;
        const list = [];

        if (!this.scale || !this.scale.proficiencies) {
            this.values.list = list;
            return;
        }

        this.scale.proficiencies.forEach(p => {
            const translations = p.skillProficiencyI18n || {};
            const value = (translations[lang] && translations[lang].value) || (p.activeI18n && p.activeI18n.value) || '';
            list.push({ points: p.points, summary: value });
        });

        this.values.list = list;
    }

    addMoreLevels (count = 1, defaultSummary = '') {
        this.resetErrors();
        const codes = Array.isArray(this.languages)
            ? this.languages.map(l => l && l.label).filter(Boolean)
            : [];

        if (!this.languageData) this.languageData = {};

        // Ensure all language buckets exist
        codes.forEach(code => {
            if (!this.languageData[code]) {
                this.languageData[code] = { name: '', enabled: true, values: [] };
            }
            if (!Array.isArray(this.languageData[code].values)) {
                this.languageData[code].values = [];
            }
        });

        // Determine current maximum length
        const lengths = codes.map(code => this.languageData[code].values.length);
        const currentMax = lengths.length ? Math.max.apply(null, lengths) : 0;
        const targetLen = currentMax + count;

        if (targetLen > 10) {
            this.error = this.$translate.instant('skill.Maximum of 10 levels are allowed');
            return;
        }

        // Backfill shorter language arrays up to currentMax
        codes.forEach(code => {
            const list = this.languageData[code].values;
            while (list.length < currentMax) {
                list.push({ proficiencyId: null, points: list.length + 1, value: '' });
            }
        });

        // Append new rows for every language (only active language gets defaultSummary)
        const active = this.selectedLang || this.defaultLanguage;
        codes.forEach(code => {
            const list = this.languageData[code].values;
            while (list.length < targetLen) {
                list.push({
                    proficiencyId: null,
                    points: list.length + 1,
                    value: code === active ? defaultSummary : ''
                });
            }
        });

        // Reindex after adding
        this.reindexPoints();
    }

    removeLevel (idx) {
        this.resetErrors();
        const codes = Array.isArray(this.languages) ? this.languages.map(l => l && l.label).filter(Boolean) : [];

        codes.forEach(code => {
            const list = (this.languageData[code] && this.languageData[code].values) || [];
            if (Array.isArray(list) && typeof idx === 'number' && idx > -1) {
                list.splice(idx, 1);
            }
        });
        this.reindexPoints();
    }

    onDragEnd () {
        this.down = false;
        this.synchronizeAllLanguagesOrder();
    }

    synchronizeAllLanguagesOrder () {
        this.resetErrors();
        if (!this.languageData || !this.selectedLang) return;

        const codes = Array.isArray(this.languages)
            ? this.languages.map(l => l && l.label).filter(Boolean)
            : [];

        // Use current language as the reference for order
        const referenceList = this.languageData[this.selectedLang].values;
        if (!Array.isArray(referenceList)) return;

        // Create a mapping of old points to new index
        const oldPointsToNewIndex = {};
        referenceList.forEach((item, newIndex) => {
            if (item && typeof item.points === 'number') {
                oldPointsToNewIndex[item.points] = newIndex;
            }
        });

        // Reorder other languages based on this mapping
        codes.forEach(code => {
            if (code === this.selectedLang) return;

            const list = this.languageData[code] && this.languageData[code].values;
            if (!Array.isArray(list)) return;

            const reordered = new Array(list.length);
            list.forEach(item => {
                if (item && typeof item.points === 'number') {
                    const newIndex = oldPointsToNewIndex[item.points];
                    if (typeof newIndex === 'number' && newIndex < reordered.length) {
                        reordered[newIndex] = item;
                    }
                }
            });

            this.languageData[code].values = reordered.filter(Boolean);
        });

        // Finally reindex all points
        this.reindexPoints();
    }

    reindexPoints () {
        this.resetErrors();
        if (!this.languageData) return;
        Object.keys(this.languageData).forEach(code => {
            const list = this.languageData[code] && this.languageData[code].values;
            if (Array.isArray(list)) {
                list.forEach((row, i) => {
                    if (row) row.points = i + 1;
                });
            }
        });
    }

    getActiveList () {
        const code = this.selectedLang;
        if (!this.languageData[code]) this.languageData[code] = { enabled: false, name: '', values: [] };
        if (!Array.isArray(this.languageData[code].values)) this.languageData[code].values = [];
        return this.languageData[code].values;
    }

    getSortedLanguages () {
        let existingScales = this.languageData;
        if (this.scale && this.scale.scaleI18ns) {
            existingScales = this.scale.scaleI18ns;
        }
        const langs = [];
        this.companySupportedLanguages.forEach(lang => {
            const langEnabled = (existingScales[lang])
                ? !!this.scale.scaleI18ns[lang].isEnabled : false;
            langs.push({ label: lang, enabled: langEnabled });
        });

        const defaultLang = (this.TokenService.getCompanyLanguage() || '').toUpperCase();
        return langs.sort((a, b) => {
            if (a.label === defaultLang) return -1;
            if (b.label === defaultLang) return 1;
            return 0;
        });
    }

    getDefaultLanguage () {
        if (Array.isArray(this.languages)) {
            // Since languages are already sorted with Company Default first:
            // 1. Try to find the first enabled language.
            const firstEnabled = this.languages.find(l => l.enabled);
            if (firstEnabled) {
                return firstEnabled.label;
            }
            // 2. If no language is enabled, default to the first language in the list (which is the company default).
            if (this.languages.length > 0) {
                return this.languages[0].label;
            }
        }
        // Fallback for empty list or other issues
        return (this.TokenService.getCompanyLanguage() || '').toUpperCase();
    }

    checkIfScaleAssociatedToSkill () {
        return (this.scale.skills && this.scale.skills.length > 0);
    }

    resetErrors () {
        this.error = '';
    }

    beforeSave () {
        this.resetErrors();
        this.reindexPoints();

        const baseLangEntry = (Array.isArray(this.languages) && (this.languages.find(l => l && l.label === this.defaultLanguage) || this.languages[0])) || null;
        const baseLang = (baseLangEntry && baseLangEntry.label) || this.selectedLang || this.defaultLanguage;
        const baseBucket = (this.languageData && this.languageData[baseLang]) || { name: '', values: [] };

        const list = Array.isArray(baseBucket.values) ? baseBucket.values : [];

        // Only contains valid, non-empty levels for base language.
        const cleanedPointsData = list
            .map((value, i) => (
                    { points: i + 1, value: (value && value.value) ? value.value : '' }
                )
            );

        if (cleanedPointsData.length < 2 || cleanedPointsData.length > 10) {
            this.error = this.$translate.instant('skill.Please add at least 2 or maximum 10 scales');
            return null;
        }

        const payload = {};
        const proficiency = {};
        if (this.languageData && Array.isArray(this.languages)) {
            this.languages.forEach(l => {
                const code = l && l.label;
                if (!code) return;

                payload[code] = {
                    is_enabled: this.languageData[code].enabled ? 1 : 0,
                    name: this.languageData[code].name
                };
                proficiency[code] = this.languageData[code].values;
            });
        }

        return {
            scaleI18ns: payload,
            proficiencies: proficiency
        };
    }

    save () {
        const payload = this.beforeSave();
        if (!payload) return;
        this.saving = true;
        const promise = this.skillScaleResource.update({ id: this.scale.id }, payload).$promise;
        promise.then((res) => {
            this.saving = false;
            this.uibModalInstance.close(res);
            this.toastr.success(this.$translate.instant('skill.Changes saved'));
        }).catch((err) => {
            this.saving = false;
            if (err.data.length) {
                this.toastr.error(err.data[0].message);
                this.error = err.data[0].message;
            }
        });
    }

    getAssociationWarning () {
        if (this.hasSkillsAssociation && this.hasPlanningGroupsAssociation) {
            return this.$translate.instant('skill.Scale cannot be edited when associated to skills and planning groups');
        }
        if (this.hasSkillsAssociation) {
            return this.$translate.instant('skill.Scale cannot be edited when associated to skills');
        }
        if (this.hasPlanningGroupsAssociation) {
            return this.$translate.instant('skill.Scale cannot be edited when associated to planning groups');
        }
        return '';
    }

    goToSkill (skillId) {
        this.uibModalInstance.dismiss();
        this.$state.go('authorized.user.skill.edit.skill', { id: skillId });
    }

    goToPlanningGroup (apg) {
        this.uibModalInstance.dismiss();
        this.$state.go('authorized.courses.courses.edit.occurrence.automated.edit.general', {
            id: apg.courseId,
            planningGroupId: apg.id
        });
    }
}




// WEBPACK FOOTER //
// ./src/app/components/modals/user/skills/scale/edit/index.js